import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import * as echarts from 'echarts';
import dataV from '@jiaminghi/data-view'
import request from './utils/request'
import Vue2OrgTree from 'vue2-org-tree'
import '@/assets/globalMixin.js'


// 引入全局样式文件
import './styles/global.css'
import './styles/colors.css'
 import VxeUI from 'vxe-pc-ui'
 import 'vxe-pc-ui/lib/style.css'

 import VxeUITable from 'vxe-table'
 import 'vxe-table/lib/style.css'

 import './assets/css/global.css'

 import { SYSTEM_NAME } from '../config.js'

 Vue.use(VxeUI)
 Vue.use(VxeUITable)

Vue.use(ElementUI, { size: 'small' })
Vue.use(dataV)
Vue.prototype.$request = request
// window.API_URL = 'http://192.168.31.165:8082';
// window.API_URL = 'http://106.14.209.141:8082';
// window.API_URL = 'http://150.158.32.240:8082';
// window.API_URL = 'http://115.120.241.249:8082'
window.API_URL = 'http://43.160.236.121:8082/buagents';
//window.API_URL = 'http://localhost:8082';



// // 全局错误处理
// Vue.config.errorHandler = function (err, vm, info) {
//   console.error(err)
//   // 跳转到指定的错误页面
//   router.push({ name: 'ErrorPage' })
// }


Vue.prototype.$echarts = function (el) {
  return echarts.init(el, null, {renderer: 'svg'})
}

Vue.directive('title', {
  inserted: function (el, binding) {
    document.title = el.dataset.title
  }
})

async function bootstrap() {
  let finalAppName = SYSTEM_NAME;

  try {
    const res = await request.get('/systemStorage/config/app-name');
    
    if (res && res.data && res.data.systemStorage) {
        finalAppName = res.data.systemStorage;
        console.log('✅ 已从服务器加载系统名称:', finalAppName);
    } else {
        console.warn('⚠️ 接口返回格式不符合预期，使用默认名称:', res);
    }

  } catch (error) {
    console.warn('❌ 获取系统线上配置失败，将使用本地默认配置', error);
  }

  Vue.prototype.$appName = finalAppName;

  new Vue({
    router,
    render: h => h(App)
  }).$mount('#app');
}

// 执行启动
bootstrap();